import backgroundLineSvg from "images/Moon.svg";
import rightImgDemo from "images/promo2.png";
import { FC } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useCollege } from "store/utils/hooks";

export interface SectionPromo2Props {
  className?: string;
}

const SectionPromo2: FC<SectionPromo2Props> = ({ className = "lg:pt-10" }) => {
  const college = useCollege();
  const homeDescription =
    college?.home_description ||
    "<h1>Educamos contigo</h2><p>En Momoi fabricamos uniformes escolares de alta calidad y, a su vez, transmitimos al alumno unos valores educativos apropiados a la sociedad en la que vivimos. Nuestros uniformes llevan este ADN, generamos un apoyo directo al colegio. Educamos contigo.</p>";
    
  const moreInfoLink = college?.more_info_link || "https://momoiescolar.com/";
  return (
    <div className={`nc-SectionPromo2 ${className}`}>
      <div className="relative overflow-hidden flex flex-col lg:flex-row lg:justify-end bg-[#F9F3B2] dark:bg-slate-800 rounded-2xl sm:rounded-[40px] p-4 pb-0 sm:p-5 sm:pb-0 lg:p-24">
        <div className="absolute inset-0">
          <img
            className="absolute w-full h-full object-contain dark:opacity-5"
            src={backgroundLineSvg}
            alt="backgroundLineSvg"
          />
        </div>
        
        <div className="w-full max-w-xl relative">
          {/* <Logo className="w-28" /> */}
          <div 
            className="mt-6 sm:mt-10 home-description-content"
            dangerouslySetInnerHTML={{ __html: homeDescription }}
          />
          <div className="flex space-x-2 sm:space-x-5 mt-6 sm:mt-12">
            <a href={moreInfoLink} target="_blank" rel="noopener noreferrer">
              <ButtonPrimary className="dark:bg-slate-200 dark:text-slate-900">
                MÁS INFORMACIÓN
              </ButtonPrimary>
            </a>
          </div>
        </div>
        <img src={college?.promotion_image || rightImgDemo} className="max-h-full lg:absolute left-0 bottom-0 mt-10 lg:mt-0 max-w-xl lg:max-w-[calc(55%-40px)] object-cover"/>
      </div>
    </div>
  );
};

export default SectionPromo2;
